export const HOMEPAGE: string = '/'
export const LOGIN: string = '/login'
export const FUNCTION_LIST: string = '/function-list'
export const PREVIEW_COHORT: string = '/preview-cohort'
export const COHORT_LIST: string = '/cohort-list'
export const FILTER = (id?: string): string => id ? `/filter/${id}` : '/filter/:id'
export const WEPAYOUT_VALIDATION_URL = (id: string) => `/v3/wepayout/validate/cohort/${id}`